module.exports = __webpack_public_path__ + "static/media/light_planing_no_data.db9073ca.png";